import { MaintenanceForwardingCheckinEntryKlass } from "../../../../types/forwardings/checkinEntries/checkinEntry.type";

export const checkinEntryOptions: {
  [K in MaintenanceForwardingCheckinEntryKlass]: {
    title: string;
    description: string | undefined;
  }
} = {
  [MaintenanceForwardingCheckinEntryKlass.TransportAutoEntry]: {
    title: 'Auto-locomoção',
    description: 'Informe um usuário na sua empresa para transporte do equipamento, se aceito, o usuário será notificado.',
  },
}
